/* TMC — FX LAYER (v1.0). Reads window.hwFx = {cursor,tilt,parallax,trans,splash,logo,home}. */
(function(){
  var fx=window.hwFx||{},H=document.documentElement,rm=window.matchMedia('(prefers-reduced-motion: reduce)').matches,coarse=window.matchMedia('(pointer: coarse)').matches;

  /* ---------- cursor light ---------- */
  if(fx.cursor&&!rm&&!coarse){
    var c=document.createElement('div');c.className='hw-cursor';c.setAttribute('aria-hidden','true');
    var tx=innerWidth/2,ty=innerHeight/2,cx=tx,cy=ty,seen=false;
    document.addEventListener('DOMContentLoaded',function(){document.body.appendChild(c)});
    window.addEventListener('pointermove',function(e){tx=e.clientX;ty=e.clientY;if(!seen){seen=true;H.classList.add('hw-cursor-on')}},{passive:true});
    document.addEventListener('mouseleave',function(){H.classList.remove('hw-cursor-on')});
    document.addEventListener('mouseenter',function(){if(seen)H.classList.add('hw-cursor-on')});
    document.addEventListener('pointerover',function(e){var t=e.target.closest&&e.target.closest('a,button,.hw-pc,.hw-tile,.hw-stone,.card-wrapper');c.classList.toggle('is-hot',!!t)},{passive:true});
    (function loop(){cx+=(tx-cx)*.14;cy+=(ty-cy)*.14;c.style.transform='translate3d('+cx.toFixed(1)+'px,'+cy.toFixed(1)+'px,0)';requestAnimationFrame(loop)})();
  }

  /* ---------- 3D tilt ---------- */
  if(fx.tilt&&!rm&&!coarse){
    var SEL='.hw-pc,.hw-stone,.hw-tile,.card-wrapper',MAX=7;
    function bind(el){
      if(el.dataset.hwTilt)return;el.dataset.hwTilt='1';el.classList.add('hw-tilt-host');
      var base=el.classList.contains('hw-pc')?'translateY(-8px)':(el.classList.contains('hw-stone')||el.classList.contains('card-wrapper'))?'translateY(-6px)':'translateY(-4px)';
      el.addEventListener('pointermove',function(e){
        var r=el.getBoundingClientRect(),px=(e.clientX-r.left)/r.width,py=(e.clientY-r.top)/r.height;
        var rx=((py-.5)*-2*MAX).toFixed(2),ry=((px-.5)*2*MAX).toFixed(2);
        el.classList.remove('is-leaving');
        el.style.transform='perspective(1100px) '+base+' rotateX('+rx+'deg) rotateY('+ry+'deg)';
        el.style.setProperty('--tx',(px*100).toFixed(1)+'%');el.style.setProperty('--ty',(py*100).toFixed(1)+'%');
      });
      el.addEventListener('pointerleave',function(){el.classList.add('is-leaving');el.style.transform='';});
    }
    function scan(){document.querySelectorAll(SEL).forEach(bind)}
    document.addEventListener('DOMContentLoaded',scan);scan();
    new MutationObserver(function(){scan()}).observe(H,{childList:true,subtree:true});
  }

  /* ---------- parallax hero ---------- */
  if(fx.parallax&&!rm){
    var hero=null,ticking=false;
    function onScroll(){
      if(!hero){hero=document.querySelector('.hw-hero');if(!hero)return}
      if(ticking)return;ticking=true;
      requestAnimationFrame(function(){
        var y=window.scrollY||0,lim=hero.offsetHeight||800;if(y>lim*1.2){ticking=false;return}
        H.style.setProperty('--hw-px',(y*.22).toFixed(1)+'px');
        H.style.setProperty('--hw-pxm',(y*.34).toFixed(1)+'px');
        H.style.setProperty('--hw-pxc',(y*-.08).toFixed(1)+'px');
        ticking=false;
      });
    }
    window.addEventListener('scroll',onScroll,{passive:true});document.addEventListener('DOMContentLoaded',onScroll);
  }

  /* ---------- page transitions ---------- */
  if(fx.trans&&!rm){
    var cur=document.createElement('div');cur.className='hw-curtain';cur.setAttribute('aria-hidden','true');
    H.classList.add('hw-entering');
    document.addEventListener('DOMContentLoaded',function(){document.body.appendChild(cur);requestAnimationFrame(function(){requestAnimationFrame(function(){H.classList.remove('hw-entering');H.classList.add('hw-entered')})})});
    window.addEventListener('pageshow',function(e){if(e.persisted){H.classList.remove('hw-leaving','hw-entering');H.classList.add('hw-entered')}});
    document.addEventListener('click',function(e){
      if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
      var a=e.target.closest&&e.target.closest('a[href]');if(!a)return;
      var href=a.getAttribute('href')||'';
      if(a.target==='_blank'||a.hasAttribute('download')||href.charAt(0)==='#'||/^(mailto|tel|javascript):/i.test(href))return;
      var url;try{url=new URL(a.href,location.href)}catch(x){return}
      if(url.origin!==location.origin)return;
      if(url.pathname===location.pathname&&url.search===location.search)return;
      if(a.closest('.shopify-section-header, cart-drawer, .menu-drawer, .header__search')&&a.closest('cart-drawer'))return;
      if(window.Shopify&&Shopify.designMode)return;
      e.preventDefault();H.classList.remove('hw-entered');H.classList.add('hw-leaving');
      setTimeout(function(){location.href=url.href},340);
    },true);
  }

  /* ---------- intro splash (homepage, once per session) ---------- */
  if(fx.splash&&!rm&&fx.home&&fx.logo){
    var key='hw_splash_seen';
    var seenS=false;try{seenS=sessionStorage.getItem(key)==='1'}catch(x){}
    if(!seenS&&!(window.Shopify&&Shopify.designMode)){
      try{sessionStorage.setItem(key,'1')}catch(x){}
      var s=document.createElement('div');s.className='hw-splash';s.setAttribute('aria-hidden','true');
      s.innerHTML='<div class="hw-splash-mark"><img src="'+fx.logo+'" alt=""></div><span class="hw-splash-line"></span><span class="hw-splash-word">'+(fx.brand||'Twisted Mind Collective')+'</span>';
      function mount(){document.body.appendChild(s);document.body.style.overflow='hidden';setTimeout(function(){s.classList.add('is-out');document.body.style.overflow='';setTimeout(function(){s.remove()},700)},1650)}
      if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',mount)}else{mount()}
    }
  }
})();
